import * as Yup from 'yup';
import {
  email,
  phoneNumber,
  postalCode,
  propertyId,
  stringMax,
} from '@/lib/yup';

const SalesOrderFormSchema = Yup.object({
  name: stringMax(50).required('validation.is_required'),
  address: stringMax(50).required('validation.is_required'),
  postal_code: postalCode.required('validation.is_required'),
  city: stringMax(50).required('validation.is_required'),
  email: email.required('validation.is_required'),
  phone_number: phoneNumber.required('validation.is_required'),
  property_municipality: stringMax(50).required('validation.is_required'),
  property_description: stringMax(1000),
  property_id: propertyId,
  property_type: stringMax(20),
  area: Yup.number()
    .transform((val: string, orig) => (orig === '' ? undefined : val))
    .typeError('validation.invalid_number')
    .max(10000, { message: 'validation.value_too_large' })
    .nullable(),
  forest_area: Yup.number()
    .transform((val: string, orig) => (orig === '' ? undefined : val))
    .typeError('validation.invalid_number')
    .max(10000, { message: 'validation.value_too_large' })
    .nullable(),
  property_address: stringMax(50),
  property_postal_code: Yup.string().matches(/^\d{5}$/, {
    message: 'validation.invalid_postal_code',
  }),
});

export type SalesOrderFormSchemaType = Yup.InferType<
  typeof SalesOrderFormSchema
>;

export default SalesOrderFormSchema;
